import { useCallback } from "react";

import { makeStyles, Snackbar as MaterialSnackbar } from "@material-ui/core";

import { useSnackbar } from "./SnackbarProvider";
import { sidebarBreakpoint, sidebarWidth } from "../../layout/Sidebar";

const useStyles = makeStyles(theme => ({
    anchorOriginBottomCenter: {
        [theme.breakpoints.up(sidebarBreakpoint)]: {
            left: `calc(50% + ${sidebarWidth}px)`,
            right: "auto",
            bottom: "24px",
            transform: `translateX(calc(-50% - ${sidebarWidth / 2}px))`,
        },
        [theme.breakpoints.up(560)]: {
            minWidth: "544px",
        },
    },
}));

interface SnackbarProps {
    children: React.ReactElement;
}

export const Snackbar = (props: SnackbarProps) => {
    const classes = useStyles();

    const { children } = props;
    const { open, closeSnackbar } = useSnackbar();

    const close = useCallback((_: any, reason?: string) => {
        if ( reason === "clickaway" ) return;

        closeSnackbar();
    }, [closeSnackbar]);

    return (
        <MaterialSnackbar open={open} autoHideDuration={3000} onClose={close} classes={classes}>
            {children}
        </MaterialSnackbar>
    );
}
